<template>
    <div class="phonetic-inputs">
        <button
            class="phonetic-input"
            :class="selectionClass(index)"
            v-for="(phone, index) in $store.state.answerData.transcriptionSegmental"
            @click="setSelectedIdx(index)">
            <span class="phonetic-input__value">
                <span class="phonetic-input__value-phone">{{ getPhone(phone) }}</span>
                <span
                    v-if="getDiacritic(phone)"
                    class="phonetic-input__value-diacritic"
                    :class="getDiacriticClass(phone)">{{ getDiacritic(phone) }}</span>
            </span>
            <div class="input-number">
                <span class="input-number__text">{{ index+1 }}</span>
            </div>
        </button>
    </div>
</template>
<script>
    export default {
        computed: {
            curQuestion(){
                let questionSet    = this.$store.state.questionSet;
                let idxCurQuestion = this.$store.state.practiceSession.idxCurQuestion;
                return questionSet[idxCurQuestion];
            }
        },

        methods: {
            getPhone(phone){
                if(!phone){
                    return '';
                }

                // Get the phone of the phone.
                let results = phone.match(this.$store.state.pattern.transcriptionSegment);
                return results[1];
            },

            getDiacritic(phone){
                if(!phone){
                    return '';
                }

                // Get the diacritic of the phone.
                let results = phone.match(this.$store.state.pattern.transcriptionSegment);
                return results[2];
            },

            getDiacriticClass(phone){
                // Get the diacritic of the phone.
                let results = phone.match(this.$store.state.pattern.transcriptionSegment);
                if(results[2] == 'ʰ'){
                    return 'phonetic-input--aspirated';
                }
                if(results[2] == '•'){
                    return 'phonetic-input--shift'
                }
                if(results[2] == ':'){
                    return 'phonetic-input--long';
                }
                return '';
            },

            selectionClass(idx){
                return idx == this.$store.state.idxSelectedPhoneticInput ? 'phonetic-input--selected' : '';
            },

            setSelectedIdx(idx){
                this.$store.commit('setIdxSelectedPhoneticInput', idx);
            }
        },
    };
</script>
<style scoped src="@/css/components/phonetic-inputs.css"></style>